"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _Breadcrumbs = _interopRequireDefault(require("./components/Breadcrumbs"));
var _JsonEditor = _interopRequireDefault(require("./components/JsonEditor"));
var _gui = require("../../reducers/gui.js");
var _gui2 = require("../../selectors/gui.js");
var _getBreadcrumbs = _interopRequireDefault(require("./getBreadcrumbs.js"));
var _getUrlPath = _interopRequireDefault(require("../../helpers/getUrlPath.js"));
var _pathToUrl = _interopRequireDefault(require("../../helpers/pathToUrl.js"));
var _forms = _interopRequireDefault(require("./forms"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Fortress = window.cccisd.fortress;
var Component = /*#__PURE__*/function (_React$Component) {
  function Component() {
    var _this;
    _classCallCheck(this, Component);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Component, [].concat(args));
    _defineProperty(_this, "state", {
      loading: true,
      updateSettingsCounter: 0
    });
    _defineProperty(_this, "componentDidMount", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            window.addEventListener('beforeunload', _this._handleUnload);
            _this.props.setBasePath(_this.props.path);
            _context.n = 1;
            return _this.loadSettings();
          case 1:
            _this.setPathFromUrl();
          case 2:
            return _context.a(2);
        }
      }, _callee);
    })));
    _defineProperty(_this, "componentDidUpdate", function () {
      _this.setPathFromUrl();
    });
    _defineProperty(_this, "_handleUnload", function (event) {
      if (_this.props.hasChanges) {
        var message = 'Your work is not saved! Are you sure you want to leave?';
        event.returnValue = message;
        return message;
      }
    });
    _defineProperty(_this, "_renderPromptUnsavedChanges", function () {
      return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Prompt, {
        when: _this.props.hasChanges,
        message: function message(location) {
          return location.pathname.startsWith('/appdefs/admin/json-editor') ? true : "Your work is not saved! Are you sure you want to leave?";
        }
      });
    });
    _defineProperty(_this, "_renderActions", function (field) {
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "mb-3 d-flex justify-content-between"
      }, /*#__PURE__*/_react["default"].createElement("h2", null, _this.props.title || 'App Settings'), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn ".concat(_this.props.hasChanges ? 'btn-warning' : 'btn-secondary'),
        onClick: _this.saveSettings,
        type: "button"
      }, "Save"))), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginBottom: '1em'
        }
      }, /*#__PURE__*/_react["default"].createElement(_Breadcrumbs["default"], {
        list: _this.props.breadcrumbs,
        setPath: _this.setPath
      })));
    });
    _defineProperty(_this, "loadSettings", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            _context2.n = 1;
            return _this.props.initializeFiles({
              filenames: _this.props.filenames,
              projectId: _this.props.projectId
            });
          case 1:
            _context2.n = 2;
            return _this.props.loadSettings();
          case 2:
            _this.setState({
              loading: false
            });
          case 3:
            return _context2.a(2);
        }
      }, _callee2);
    })));
    _defineProperty(_this, "setPathToUrl", function (path) {
      var urlPath = (0, _getUrlPath["default"])(_this.props.basePath, _this.props.match.params.path);
      if (path === urlPath) {
        return;
      }
      var url = _this.props.match.path.replace('/:path?', (0, _pathToUrl["default"])(_this.props.basePath, path));
      for (var _i = 0, _Object$entries = Object.entries(_this.props.match.params); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];
        url = url.replace(":".concat(key), value);
      }
      _this.props.history.push(url);
    });
    _defineProperty(_this, "setPathFromUrl", function () {
      var urlPath = (0, _getUrlPath["default"])(_this.props.basePath, _this.props.match.params.path);
      if (urlPath !== _this.props.currentPath) {
        _this.setPath('/' + urlPath);
      }
    });
    _defineProperty(_this, "setPath", function (path) {
      _this.props.setPath({
        path: path,
        setPathToUrl: _this.setPathToUrl
      });
    });
    _defineProperty(_this, "saveSettings", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(event) {
        var overwriteAllModified,
          response,
          _args3 = arguments,
          _t;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              overwriteAllModified = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : false;
              _context3.n = 1;
              return _this.props.saveSettings(overwriteAllModified, _this.props.projectId);
            case 1:
              response = _context3.v;
              if (!(response.status !== 200)) {
                _context3.n = 2;
                break;
              }
              (0, _cccisdNotification["default"])({
                duration: 2250,
                message: 'Encountered error while writing file',
                type: 'danger'
              });
              _context3.n = 10;
              break;
            case 2:
              if (!(response.data.status === 'error')) {
                _context3.n = 9;
                break;
              }
              if (!(Object.keys(response.data.errors).length === 1 && response.data.errors.modified_since_retrieval)) {
                _context3.n = 7;
                break;
              }
              _context3.p = 3;
              _context3.n = 4;
              return (0, _cccisdConfirm["default"])({
                message: "Warning: The files on the filesystem were updated while you've been working.",
                description: 'Would you like to overwrite all?'
              });
            case 4:
              _this.saveSettings(null, true);
              _context3.n = 6;
              break;
            case 5:
              _context3.p = 5;
              _t = _context3.v;
            case 6:
              _context3.n = 8;
              break;
            case 7:
              (0, _cccisdNotification["default"])({
                duration: -1,
                message: 'Encountered error while writing file',
                type: 'danger',
                data: response.data.errors
              });
            case 8:
              _context3.n = 10;
              break;
            case 9:
              if (response.status === 200) {
                // reload after saving app settings to see changes elsewhere in the app
                window.location.reload();
              }
            case 10:
              return _context3.a(2);
          }
        }, _callee3, null, [[3, 5]]);
      }));
      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "onUpdate", function (values) {
      _this.props.updateSettings({
        path: _this.props.currentPath,
        settings: values
      });
    });
    _defineProperty(_this, "onUpdateSettings", function (values) {
      _this.onUpdate(values);
      _this.setState(function (prevState) {
        return {
          updateSettingsCounter: prevState.updateSettingsCounter + 1
        };
      });
    });
    return _this;
  }
  _inherits(Component, _React$Component);
  return _createClass(Component, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('beforeunload', this._handleUnload);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      if (this.state.loading) {
        return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], null);
      }
      var _this$props = this.props,
        breadcrumbs = _this$props.breadcrumbs,
        hasChanges = _this$props.hasChanges,
        currentPath = _this$props.currentPath,
        rerenderFlag = _this$props.rerenderFlag,
        settings = _this$props.settings;
      var initialValue = currentPath === '' ? settings : (0, _get2["default"])(settings, currentPath);
      if (!initialValue) {
        return /*#__PURE__*/_react["default"].createElement("div", null, this._renderActions(), this._renderPromptUnsavedChanges(), /*#__PURE__*/_react["default"].createElement("div", {
          className: "alert alert-danger"
        }, "There are no settings for \"".concat(currentPath, "\" path")));
      }
      if (_typeof(initialValue) !== 'object') {
        return /*#__PURE__*/_react["default"].createElement("div", null, this._renderActions(), this._renderPromptUnsavedChanges(), /*#__PURE__*/_react["default"].createElement("div", {
          className: "alert alert-danger"
        }, "Settings should be an array or an object for \"".concat(currentPath, "\" path")));
      }
      var generalPath = currentPath.replace(/\[\d+\]/g, '[x]');
      var currentForm = _forms["default"].find(function (item) {
        return item.path === generalPath;
      });
      if (!currentForm) {
        return /*#__PURE__*/_react["default"].createElement("div", null, this.renderActions(), this._renderPromptUnsavedChanges(), /*#__PURE__*/_react["default"].createElement("div", {
          className: "alert alert-danger"
        }, "Cannot find the form for the \"".concat(currentPath, "\" path")));
      }
      var pathProps = {};
      if (currentForm.componentPathProps) {
        var pathNumbers = currentPath.match(/\[\d+\]/g);
        var _loop = function _loop() {
            var prop = _Object$keys[_i2];
            var pathProp = currentForm.componentPathProps[prop];
            if (/\[x\]/.test(pathProp) && !currentForm.path.includes(pathProp)) {
              return {
                v: /*#__PURE__*/_react["default"].createElement("div", null, _this2.renderActions(), _this2._renderPromptUnsavedChanges(), /*#__PURE__*/_react["default"].createElement("div", {
                  className: "alert alert-danger"
                }, "Path prop \"".concat(pathProp, "\" should be part of path \"").concat(currentPath, "\"")))
              };
            }
            var count = 0;
            pathProps[prop] = (0, _get2["default"])(settings, pathProp.replace(/\[x\]/g, function (item) {
              return pathNumbers[count++];
            }));
          },
          _ret;
        for (var _i2 = 0, _Object$keys = Object.keys(currentForm.componentPathProps); _i2 < _Object$keys.length; _i2++) {
          _ret = _loop();
          if (_ret) return _ret.v;
        }
      }
      var field = {
        name: "settings.".concat(this.state.updateSettingsCounter, ".").concat(currentPath),
        onChange: this.onUpdate,
        value: initialValue
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: rerenderFlag
      }, this._renderPromptUnsavedChanges(), /*#__PURE__*/_react["default"].createElement("div", {
        className: "mb-3 d-flex justify-content-between"
      }, /*#__PURE__*/_react["default"].createElement("h2", null, this.props.title || 'App Settings'), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn ".concat(hasChanges ? 'btn-warning' : 'btn-secondary'),
        onClick: this.saveSettings,
        type: "button"
      }, "Save"))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "mb-3"
      }, /*#__PURE__*/_react["default"].createElement(_Breadcrumbs["default"], {
        list: breadcrumbs,
        setPath: this.setPath,
        rightBlock: Fortress.user.acting.is_super_user ? /*#__PURE__*/_react["default"].createElement(_JsonEditor["default"], {
          trigger: /*#__PURE__*/_react["default"].createElement("button", {
            className: "btn btn-secondary btn-xs",
            type: "button"
          }, "Edit JSON"),
          field: field
        }) : null
      })), /*#__PURE__*/_react["default"].createElement(currentForm.component, _extends({
        key: this.state.updateSettingsCounter,
        field: field,
        setPath: this.setPath,
        onUpdateSettings: this.onUpdateSettings
      }, pathProps, {
        options: this.props.options
      })));
    }
  }]);
}(_react["default"].Component);
_defineProperty(Component, "propTypes", {
  basePath: _propTypes["default"].string,
  breadcrumbs: _propTypes["default"].array,
  currentPath: _propTypes["default"].string,
  filenames: _propTypes["default"].array,
  history: _propTypes["default"].object,
  match: _propTypes["default"].object,
  options: _propTypes["default"].object,
  path: _propTypes["default"].string,
  projectId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  rerenderFlag: _propTypes["default"].bool,
  settings: _propTypes["default"].object,
  title: _propTypes["default"].string,
  /** From redux */
  hasChanges: _propTypes["default"].bool,
  initializeFiles: _propTypes["default"].func,
  loadSettings: _propTypes["default"].func,
  saveSettings: _propTypes["default"].func,
  setBasePath: _propTypes["default"].func,
  setPath: _propTypes["default"].func,
  updateSettings: _propTypes["default"].func
});
_defineProperty(Component, "defaultProps", {
  path: '',
  options: {}
});
var mapStateToProps = function mapStateToProps(state, props) {
  var _state$appdefs$gui = state.appdefs.gui,
    settings = _state$appdefs$gui.settings,
    basePath = _state$appdefs$gui.basePath,
    path = _state$appdefs$gui.path;
  return {
    breadcrumbs: (0, _getBreadcrumbs["default"])(settings, basePath, path),
    hasChanges: (0, _gui2.getHasChanges)(state.appdefs.gui),
    basePath: basePath,
    currentPath: path,
    rerenderFlag: state.appdefs.gui.rerenderFlag,
    settings: settings
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, {
  setPath: _gui.setPath,
  initializeFiles: _gui.initializeFiles,
  loadSettings: _gui.loadSettings,
  saveSettings: _gui.saveSettings,
  updateSettings: _gui.updateSettings,
  setBasePath: _gui.setBasePath
})(Component);